import { useTranslation } from 'react-i18next';
import { ButtonFilters, FilterType, LoadingIndicator, Stepper } from '@triumph/design-system';
import { useGetInvoiceActivities } from '@/app/shared/api/endpoints/searchInvoiceActivities';
import { InvoiceNotesCardTypes } from './InvoiceNotesCard.types';
import { useActivityFilters } from '@/app/shared/utils/hooks/invoiceActivityHooks/useActivityFilters';
import {
    InvoiceNotesHeader,
    InvoiceNotesCard as StyledInvoiceNotesCard,
    ActivityHeader,
    StepperWrapper,
} from '../InvoiceDetail.StyledComponents';

export const InvoiceNotesCard: React.FC<InvoiceNotesCardTypes> = (props) => {
    const { t } = useTranslation('invoicesDashboard');

    const { data: activities, isLoading, isError } = useGetInvoiceActivities({
        assetId: props.invoiceDetails?.invoiceId ?? 0
    });

    const invoiceNumber = props.invoiceDetails?.invoiceNumber ?? '';

    const {
        sortedActivities,
        getActivityTypes,
        handleFilterChange,
    } = useActivityFilters(activities, invoiceNumber);

    if (isLoading) {
        return (
            <StyledInvoiceNotesCard>
                <LoadingIndicator/>
            </StyledInvoiceNotesCard>
        );
    }

    if (isError) {
        return (
            <StyledInvoiceNotesCard>
                {t('invoiceDetail.invoiceNotesError')}
            </StyledInvoiceNotesCard>
        );
    }

    return (
        <StyledInvoiceNotesCard>
            <ActivityHeader>
                <InvoiceNotesHeader>
                    {t('invoiceDetail.invoiceNotesHeader')}
                </InvoiceNotesHeader>
                <ButtonFilters
                    id="activityTypeFilter"
                    filters={[
                        {
                            id: 'activityTypeFilter',
                            column: 'activityType',
                            filterType: FilterType.Button,
                            label: t('invoiceDetail.filterButtonText', 'Activity Type'),
                            getData: getActivityTypes,
                            disableSearch: true,
                            title: t('invoiceDetail.activityTitle', 'Notes'),
                            header: t('invoiceDetail.filterButtonText', 'Activity Type'),
                        },
                    ]}
                    onButtonFilterSearch={handleFilterChange}
                    hiddenColumns={[]}
                />
            </ActivityHeader>
            <StepperWrapper>
                <Stepper
                    steps={sortedActivities}
                    hideAddNote
                    timestampDateOnly={false}
                />
            </StepperWrapper>
        </StyledInvoiceNotesCard>
    );
};
